import React, { useEffect } from "react";
import styles from "./Chart.module.css";
import * as d3 from "d3";

const data = [
  {
    race: "Black",
    victimizations: 1029,
    population: 433292,
    per10000: 23.74841908,
  },
  {
    race: "White",
    victimizations: 20,
    population: 16862,
    per10000: 11.86098921,
  },
  {
    race: "Hispanic",
    victimizations: 92,
    population: 166180,
    per10000: 5.536165604,
  },
  {
    race: "All",
    victimizations: 1146,
    population: 631237,
    per10000: 18.15482933,
  },
].sort((a, b) => (a.per10000 > b.per10000 ? 1 : -1));

const renderBar = () => {
  const svg = d3.select(`#demographic-bar svg`);

  var color = d3
    .scaleOrdinal()
    .range(["#84a4b2", "#b36056", "#e2ac7e", "#333"])
    .domain(["Black", "White", "Hispanic", "All"]);
  const redraw = () => {
    svg.html(null);

    const svg_bbox = d3
      .select(`#demographic-bar svg`)
      .node()
      .getBoundingClientRect();
    const margin = { top: 0, right: 0, bottom: 0, left: 50 };
    const width = svg_bbox.width - margin.left - margin.right,
      height = svg_bbox.height - margin.top - margin.bottom;

    const x = d3.scaleLinear().range([0, width]).domain([0, 23.74841908]);
    const y = d3
      .scaleBand()
      .range([height, 0])
      .padding(0.2)
      .domain(data.map((d) => d.race));

    const barHeight = (height / data.length) * 0.75;
    const chart = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    chart
      .selectAll("bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", 0)
      .attr("y", (d) => y(d.race))
      .attr("width", (d) => x(d.per10000))
      .attr("height", barHeight)
      .style("fill", (d) => color(d.race));

    chart
      .selectAll("text")
      .data(data)
      .enter()
      .append("text")
      .attr("text-anchor", "end")
      .attr("fill", "#fff")
      .attr("font-weight", "bold")
      .attr("x", (d) => x(d.per10000) - 5)
      .attr("y", (d) => y(d.race) + barHeight / 2 + 5.5)
      .text((d) => d3.format(".1f")(d.per10000));

    const yAxis = chart.append("g").call(d3.axisLeft(y));
    yAxis.select(".domain").remove();
    yAxis.selectAll(".tick line").remove();
  };
  redraw();
  window.addEventListener("resize", redraw);
};

const DemographicsBarChart = () => {
  useEffect(() => renderBar());

  return (
    <div className={styles.container}>
      <p>
        Victimizations per 10,000 residents in priority community areas from
        2018 to 2020
      </p>
      <div id="demographic-bar">
        <svg />
      </div>
    </div>
  );
};

export default DemographicsBarChart;
